import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { CHANGE_BOARD, CHANGE_STAGE_LABEL } from '@veta-desk/domain';
import { Shell } from '../components/Shell';
import { api, type ChangeRow } from '../lib/api';
import { relativeTime } from '../lib/format';
import { useSession } from '../lib/session';

// Veta Change: tablero de cambios por etapa.

export default function Changes() {
  const { me } = useSession();
  const q = useQuery({ queryKey: ['changes'], queryFn: () => api<{ changes: ChangeRow[] }>('/change'), refetchInterval: 60_000 });
  const rows = q.data?.changes ?? [];
  const columns = CHANGE_BOARD.filter(s => rows.some(r => r.stage === s) || ['estimating', 'manager_review', 'pending_approval', 'development', 'uat'].includes(s));

  return (
    <Shell>
      <div className="flex flex-col gap-4">
        <div>
          <h1 className="text-2xl font-semibold">Cambios <span className="ml-1 rounded bg-[#EDEBE7] px-1.5 py-0.5 align-middle text-xs font-semibold text-muted">Veta Change</span></h1>
          <p className="mt-1 text-sm text-muted">Requerimientos en su flujo de estimación, cotización, aprobación, desarrollo, pruebas y paso a producción.</p>
        </div>
        {q.isLoading ? <p role="status" className="py-10 text-center text-sm text-muted">Cargando…</p> : q.isError ? (
          <p role="alert" className="rounded-md bg-white p-6 text-sm text-[#8F1D1D]">No se pudo cargar el tablero.</p>
        ) : (
          <div className="flex gap-3 overflow-x-auto pb-2">
            {columns.map(stage => {
              const items = rows.filter(r => r.stage === stage);
              const mine = stage === 'manager_review' && (me?.deskRole === 'admin' || me?.serviceManager);
              return (
                <section key={stage} className="flex w-[260px] shrink-0 flex-col gap-2 rounded-lg bg-[#EDEBE7]/60 p-2.5" aria-label={CHANGE_STAGE_LABEL[stage]}>
                  <h2 className="flex items-center justify-between px-1 text-xs font-semibold uppercase tracking-wide text-muted">
                    {CHANGE_STAGE_LABEL[stage]}
                    <span className={`rounded-full px-1.5 font-mono ${mine && items.length ? 'bg-[#C2410C] text-white' : ''}`}>{items.length}</span>
                  </h2>
                  {items.map(c => (
                    <Link key={c.number} to={`/cambios/${c.number}`} className="rounded-md border border-line bg-white p-3 text-sm hover:border-[#C9C5BD]">
                      <p className="font-mono text-xs text-accent">{c.number}</p>
                      <p className="mt-0.5 line-clamp-2 font-medium">{c.subject}</p>
                      <p className="mt-1 text-xs text-muted">{c.organizationName}</p>
                      <p className="mt-2 flex items-center justify-between text-xs text-muted">
                        <span>{c.assigneeName ?? 'Sin dueño'}</span>
                        <span>{c.estimateHours !== null ? `${c.estimateHours} h` : ''}</span>
                      </p>
                      <p className="mt-0.5 text-[11px] text-muted">{relativeTime(c.updatedAt)}</p>
                    </Link>
                  ))}
                  {items.length === 0 && <p className="px-1 py-3 text-xs text-muted">—</p>}
                </section>
              );
            })}
          </div>
        )}
      </div>
    </Shell>
  );
}
